import './ResearchPageHeader.css';

function ResearchPageHeader({ eyebrow, title, description, badges = [], statsCard = null }) {
  const centeredStats = Boolean(statsCard?.centered);
  const statsCardClassName = centeredStats ? 'research-stat-card research-stat-card--centered' : 'research-stat-card';
  const statsRowClassName = centeredStats ? 'research-stats-row research-stats-row--centered' : 'research-stats-row';
  const statClassName = centeredStats ? 'research-stat research-stat--centered' : 'research-stat';

  return (
    <header className="research-hero">
      <div className="research-hero__inner">
        <div className="research-hero__left">
          {eyebrow ? (
            <p className="research-hero-eyebrow">
              <span className="research-hero-eyebrow__dot" />
              {eyebrow}
            </p>
          ) : null}
          <h1 className="research-hero-title">{title}</h1>
          {description ? <p className="research-hero-subtitle">{description}</p> : null}
          {badges.length ? (
            <div className="research-hero-badges">
              {badges.map((badge) => (
                <span key={badge} className="research-hero-badge">{badge}</span>
              ))}
            </div>
          ) : null}
        </div>

        {statsCard ? (
          <div className="research-hero__right">
            <div className={statsCardClassName}>
              {statsCard.label ? (
                <div className="research-stat-card__live">
                  {statsCard.showDot === false ? null : <span className="research-live-dot" />}
                  {statsCard.label}
                </div>
              ) : null}
              {Array.isArray(statsCard.items) && statsCard.items.length ? (
                <div className={statsRowClassName}>
                  {statsCard.items.flatMap((item, index) => {
                    const nodes = [];
                    if (index > 0) {
                      nodes.push(<div key={`divider-${item.label}-${index}`} className="research-stat-divider" />);
                    }
                    nodes.push(
                      <div key={`${item.label}-${item.value}-${index}`} className={statClassName}>
                        <span className="research-stat__num">{item.value}</span>
                        <span className="research-stat__label">{item.label}</span>
                      </div>,
                    );
                    return nodes;
                  })}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}

export default ResearchPageHeader;
